export default {
	title: 'Plan estratégico',
	tabs: {
		general: {
			title: 'General'
		},
		filters: {
			title: 'Filtros de vista'
		},
		bot: {
			title: 'IA'
		},
		export: {
			title: 'Exportar'
		},
		display: {
			title: 'Visualización'
		}
	},
	filters: {
		responsible: {
			title: 'Filtro por responsable',
			placeholder: 'Nombre del responsable'
		},
		completion: {
			title: 'Filtro de finalización',
			not_started: 'No iniciado',
			in_progress: 'En progreso',
			completed: 'Completado'
		},
		dates: {
			title: 'Filtro de fechas'
		},
		startOn: {
			title: 'Filtro de fecha de inicio',
			undefined: 'Sin fecha',
			past: 'Pasado',
			ending_week: 'Iniciando en una semana',
			ending_month: 'Iniciando en un mes',
			ending_quarter: 'Iniciando en un trimestre',
			ending_year: 'Iniciando en un año'
		},
		endOn: {
			title: 'Filtro de fecha de fin',
			undefined: 'Sin fecha',
			done: 'Hecho',
			overdue: 'Vencido',
			ending_week: 'Finalizando en una semana',
			ending_month: 'Finalizando en un mes',
			ending_quarter: 'Finalizando en un trimestre',
			ending_year: 'Finalizando en un año'
		}
	},

	display: {
		sort: {
			title: 'Orden de las ramas',
			startOn: 'Por fecha de inicio',
			name: 'Por nombre',
			manual: 'Orden manual'
		}
	},
	all_icons: 'Filtro de iconos',
	no_icon: 'Sin icono',
	onboarding: {
		title: 'Revisión del plan de acción',
		description:
			'Verifica que los ejes e ítems coincidan con tu lectura del plan.'
	}
};
